<div class="p-4">
  <ng-container *ngIf="dashboard$ | async as dashboard">
    <h1 class="mb-3">
      Bem vindo(a) ao <strong>{{ appName }}</strong>
    </h1>
    <div class="home-cards-container">
      <div class="home-card roxo">
        <h3>Beneficiários</h3>
        <a
          mat-button
          matTooltip="Ir para Beneficiários"
          routerLink="/beneficiarios"
        >
          <h4>{{ dashboard.quantidadeDeBeneficiarios }}</h4>
        </a>

        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
      </div>

      <div class="home-card verde">
        <h3>Integrações</h3>
        <a
          mat-button
          matTooltip="Ir para Integrações"
          routerLink="/integracoes"
        >
          <div>
            <small>
              Pendentes na Fila:
              {{
                dashboard.respostasDashboardIntegracoesDTO[0]
                  .quantidadeDeIntegracoesNaFila
              }}
            </small>

            <small>
              Aceitas pela Operadora:
              {{
                dashboard.respostasDashboardIntegracoesDTO[0]
                  .quantidadeDeIntegracoesComMovimentacoesAceitas
              }}
            </small>

            <small>
              Com Críticas da Operadora:
              {{
                dashboard.respostasDashboardIntegracoesDTO[0]
                  .quantidadeDeIntegracoesComMovimentacoesRecusadas
              }}
            </small>
          </div>
        </a>

        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
      </div>
      <div class="home-card amarelo">
        <h3>Contratos Ativos</h3>
        <a mat-button matTooltip="Ir para Contratos" routerLink="/contratos">
          <h4>
            {{ dashboard.quantidadeDeContratos }}
          </h4>
        </a>

        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
      </div>
    </div>
    <div
      class="alert alert-warning d-flex justify-content-between align-items-center alert-dismissible fade show"
      role="alert"
      *ngIf="pendingOnboarding$ | async"
    >
      <div class="d-flex align-items-center">
        <fa-icon [icon]="faExclamationTriangle" class="me-3"></fa-icon>
        <div>
          Você ainda não finalizou o <strong>Onboarding</strong>.
          <button
            mat-flat-button
            color="primary"
            class="ms-3"
            routerLink="/onboarding"
          >
            Continuar Onboarding
          </button>
        </div>
      </div>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>

    <div class="content-cards-container">
      <mat-card class="p-3">
        <div class="content-card">
          <img src="../../../../../assets/images/home_image_01.svg" />
          <div class="title-container">
            <h1 class="mb-4">Praticidade</h1>
            <small class="text-muted">
              Gerencie seus Beneficiários de forma simples e fácil. Configure
              seus Contratos, Produtos, Beneficiários, faça importações e muito
              mais. Gerencie seus Beneficiários de forma simples e fácil.
              Configure seus Contratos, Produtos, Beneficiários, faça
              importações e muito mais. Gerencie seus Beneficiários de forma
              simples e fácil.
            </small>
          </div>
        </div>
      </mat-card>
      <mat-card class="p-3">
        <div class="content-card">
          <img src="../../../../../assets/images/file_import.png" />
          <div class="title-container">
            <h1 class="mb-4">Automação</h1>
            <small class="text-muted">
              Gerencie seus Beneficiários de forma simples e fácil. Configure
              seus Contratos, Produtos, Beneficiários, faça importações e muito
              mais. Gerencie seus Beneficiários de forma simples e fácil.
            </small>
          </div>
        </div>
      </mat-card>
    </div>
  </ng-container>
</div>
